import { useField } from "react-final-form";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormHelperText from "@mui/material/FormHelperText";
import FormLabel from "@mui/material/FormLabel";
import {
  ORGANIZATION_ROLE_OPTIONS,
  type OrganizationRoleType,
} from "@/admin/entities/organizationUsers";

interface RolesCheckboxGroupFieldProps {
  name: string;
  label?: string;
  helperText?: string;
}

function validateRoles(value: OrganizationRoleType[] | undefined) {
  return value && value.length > 0 ? undefined : "Выберите хотя бы одну роль";
}

// Кастомное поле формы (type: "fieldComponent"): чекбоксы ролей с
// валидацией "минимум одна роль" через react-final-form. Регистрация поля
// одна на весь чекбокс-набор (useField), в отличие от общего
// CheckboxGroupField, который регистрирует отдельное поле на каждый
// чекбокс и не даёт агрегированно провалидировать пустой набор.
export function RolesCheckboxGroupField({
  name,
  label,
  helperText,
}: RolesCheckboxGroupFieldProps) {
  const {
    input: { value, onChange },
    meta: { error, touched, submitFailed },
  } = useField<OrganizationRoleType[]>(name, { validate: validateRoles });

  const selected: OrganizationRoleType[] = value || [];
  const showError = Boolean(error) && (touched || submitFailed);

  const toggle = (role: OrganizationRoleType) => {
    onChange(
      selected.includes(role)
        ? selected.filter((r) => r !== role)
        : [...selected, role]
    );
  };

  return (
    <div>
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <FormGroup>
        {ORGANIZATION_ROLE_OPTIONS.map((option) => (
          <FormControlLabel
            key={option.value}
            control={
              <Checkbox
                checked={selected.includes(option.value)}
                onChange={() => toggle(option.value)}
              />
            }
            label={option.label}
          />
        ))}
      </FormGroup>
      <FormHelperText error={showError}>
        {showError ? error : helperText}
      </FormHelperText>
    </div>
  );
}
